var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-notifications'),(!_vm.isAuthenticated)?_c('app-login'):_c('div',[_c('app-header'),_c('app-navigation'),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }